import { State } from '../../../types/state';

export const groupsSelector = (state: State) => state.groups;
